import { useEffect, useState } from "react";

const defaultHeight = 100;

interface UseElementHeightConfig {
  defaultHeight: number;
}

export const useElementHeight = (
  elementID: string,
  config: UseElementHeightConfig = { defaultHeight }
) => {
  const [height, setHeight] = useState<number>(config.defaultHeight);
  const element = document.getElementById(elementID);
  useEffect(() => {
    const offsetHeight = element?.offsetHeight;
    const newOffsetHeight =
      offsetHeight && Number.isInteger(offsetHeight)
        ? offsetHeight
        : config.defaultHeight;
    setHeight(newOffsetHeight);
  }, [element, config.defaultHeight, elementID]);

  return height;
};
